import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserRoleDto } from 'src/app/interfaces/requests/user-role-dto';
import { UserRoleDetailDto } from 'src/app/interfaces/requests/user-role.request';
import { IFiltersUserAdministrationResponse } from 'src/app/interfaces/Responses/IFiltersUserAdministrationResponse';
import { IUserDetailResponse } from 'src/app/interfaces/Responses/IUserDetailResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserAdministrationService {

  url: string = environment.urlBaseService

  constructor(private httpClient: HttpClient) { }

  LoadFilters(): Observable<IFiltersUserAdministrationResponse> {
    return this.httpClient.get<IFiltersUserAdministrationResponse>(`${this.url}userAdministration`)
  }

  GetUserDetail(userName: string): Observable<IUserDetailResponse> {
    return this.httpClient.get<IUserDetailResponse>(`${this.url}UserAdministration/userdetail?userName=${userName}`)
  }

  InsertUserDetail(userRoleDetailDto: UserRoleDetailDto): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(userRoleDetailDto);
    return this.httpClient.post(`${this.url}UserAdministration/add`, body, { 'headers': headers })
  }

  InsertUserRol(userRoleDto: UserRoleDto): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(userRoleDto)
    return this.httpClient.post(`${this.url}UserAdministration/addUserRole`, body, { 'headers': headers })
  }

  DeleteUserRol(userRoleDto: UserRoleDto): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(userRoleDto)
    };
    
    return this.httpClient.delete(`${this.url}UserAdministration/deleteUserRole`, options)
  }

}
